import { Grid, Typography } from '@mui/material';
import { SwitchElement } from 'react-hook-form-mui';
import { FormattedMessage } from 'react-intl';

export function PlayOnCursorSetField() {
  return (
    <>
      <Grid item xs={12} md={6}>
        <Typography>
          <FormattedMessage
            id="logger.streamScreen.screenSettings.playOnCursorSet"
            defaultMessage="Reproducir al marcar"
          />
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <SwitchElement name="playOnCursorSet" label="" />
      </Grid>
    </>
  );
}
